import { useNavigationContext } from '../context';

export function useIsEmployerApp() {
  const { router } = useNavigationContext();
  const isEmployerApp = !!router?.asPath?.includes('/employer');

  return { isEmployerApp };
}
